import React from 'react';
import './Contact.css';
import Header from '../header/Header';
import Footer from '../footer/Footer';

const ContactPage = () => {
  return (
    <div>
    <Header></Header>
    <div className="contact-page">
        
      <div className="map-container">
        <img
          src="https://via.placeholder.com/600x400?text=Map+Placeholder"
          alt="Map Placeholder"
        />
      </div>
      <div className="contact-info">
        <h2>You Need Help?</h2>
        <div>
          <h3>Email Addresses</h3>
          <p><strong>Informations:</strong> info@Royalbroadband.com</p>
          <p><strong>Support:</strong> hellodubey711@gmail.com</p>
          <p><strong>Support:</strong> Kaushalmishra93111@gmail.com</p>
        </div>
        <div>
          <h3>Telephone</h3>
          <p><strong>Mobile:</strong> 8882797698 , 9870420711</p>
        </div>
        <div>
          <h3>Address</h3>
          <p><strong>HeadQuarters:</strong> Shop no 26 csc 5 dda gole market, Sector 9, Rohini, New Delhi, Delhi 110085</p>
          <p><strong>Branch:</strong> A-13, Sudan Gardan Near Gurdwara, Near Chawala Stand, Najafgarh, New Delhi, 110043</p>
          <p><strong>Branch:</strong> RZ C-13, Hanuman Chok Qutub Vihar, Phase-2, Near Sector 19, Dwarka, New Delhi, 110070</p>
        </div>
      </div>
      
    </div>
    <Footer></Footer>
   </div>
  );
};

export default ContactPage;
